import { $ } from '../lib/dom.js';
import { esc } from '../lib/escape.js';
import { NAMES } from '../data/names.js';

const VOTES_KEY = 'ggdad_votes';
const VOTED_KEY = 'ggdad_voted';

function loadVotes() {
  try {
    const stored = JSON.parse(localStorage.getItem(VOTES_KEY) || 'null');
    if (stored && typeof stored === 'object') return stored;
  } catch (e) { /* fall through */ }
  return NAMES.reduce((a, n) => (a[n.id] = n.base, a), {});
}

function persist(votes, voted) {
  try {
    localStorage.setItem(VOTES_KEY, JSON.stringify(votes));
    if (voted) localStorage.setItem(VOTED_KEY, voted);
  } catch (e) { /* quota or disabled — silently degrade */ }
}

export function renderNameLab() {
  const mount = $('#lab-mount');
  if (!mount) return;

  let votes = loadVotes();
  let voted = localStorage.getItem(VOTED_KEY) || null;

  const lab = document.createElement('div');
  lab.className = 'lab';
  lab.innerHTML = `
    <div class="lab-side">
      <span class="tag">/// LIVE TALLY</span>
      <div class="ask">What's the name<br/>going on the jersey?</div>
      <p>Five candidates. One vote per dad. Tally updates live. Whatever wins by tournament Saturday gets embroidered.</p>
      <div class="summary">
        <span>TOTAL VOTES CAST</span>
        <b id="lab-total">0</b>
        <span style="margin-top: 10px">CURRENTLY LEADING</span>
        <b id="lab-winner" style="color: var(--blaze)">—</b>
      </div>
    </div>
    <div class="options" id="lab-options"></div>
  `;
  mount.appendChild(lab);

  const share = document.createElement('div');
  share.className = 'share-card';
  share.innerHTML = `
    <div class="quote" id="share-quote"></div>
    <div class="buttons">
      <button id="share-btn-copy" type="button">↗ COPY SHARE TEXT</button>
      <button class="primary" id="share-btn-post" type="button">POST IT →</button>
    </div>
  `;
  mount.appendChild(share);

  const optsRoot = lab.querySelector('#lab-options');
  NAMES.forEach((n, i) => {
    const b = document.createElement('button');
    b.className = 'opt';
    b.type = 'button';
    b.dataset.id = n.id;
    b.innerHTML = `
      <div class="rank">0${i + 1}</div>
      <div class="text">
        <div class="name">${esc(n.name)}</div>
        <div class="slogan">"${esc(n.slogan)}"</div>
      </div>
      <div class="bar-cell"><div class="bar-bg"><div class="bar-fill" style="width:0%"></div></div></div>
      <div class="pct">0.0%<small>0 votes</small></div>
    `;
    b.addEventListener('click', () => cast(n.id));
    optsRoot.appendChild(b);
  });

  function winnerName() {
    return NAMES.reduce(
      (best, n) => (votes[n.id] || 0) > (votes[best.id] || 0) ? n : best,
      NAMES[0]
    );
  }

  function update() {
    const total = Object.values(votes).reduce((a, b) => a + b, 0);
    const winner = winnerName();
    lab.querySelector('#lab-total').textContent = total.toLocaleString();
    lab.querySelector('#lab-winner').textContent = winner.name;

    NAMES.forEach(n => {
      const b = optsRoot.querySelector(`.opt[data-id="${n.id}"]`);
      const pct = total > 0 ? ((votes[n.id] || 0) / total) * 100 : 0;
      const isVoted = voted === n.id;
      b.classList.toggle('voted', isVoted);
      b.querySelector('.bar-fill').style.width = pct + '%';
      b.querySelector('.pct').innerHTML =
        pct.toFixed(1) + '%<small>' +
        (votes[n.id] || 0).toLocaleString() + ' votes' +
        (isVoted ? ' · YOU' : '') + '</small>';
    });

    const sq = share.querySelector('#share-quote');
    if (voted) {
      const v = NAMES.find(n => n.id === voted);
      sq.innerHTML = 'You backed <span class="blaze">' + esc(v.name) +
        '</span>. Now make your dad-group-chat back it too.';
    } else {
      sq.innerHTML = 'Cast your vote. Then <span class="blaze">drop the link</span> into the dad-group-chat.';
    }
  }

  function cast(id) {
    if (voted) votes[voted] = Math.max(0, (votes[voted] || 0) - 1);
    votes[id] = (votes[id] || 0) + 1;
    voted = id;
    persist(votes, voted);
    update();
  }

  share.querySelector('#share-btn-copy').addEventListener('click', () => {
    const w = voted ? NAMES.find(n => n.id === voted) : winnerName();
    const text = `I voted for ${w.name} — "${w.slogan}"\nThe internet's first dad-only Mobile Legends esports team. Cast your vote → ggdad.gg`;
    if (navigator.clipboard) {
      navigator.clipboard.writeText(text);
      const btn = share.querySelector('#share-btn-copy');
      const og = btn.textContent;
      btn.textContent = '✓ COPIED';
      setTimeout(() => { btn.textContent = og; }, 1800);
    }
  });

  share.querySelector('#share-btn-post').addEventListener('click', () => {
    const w = voted ? NAMES.find(n => n.id === voted) : winnerName();
    const tw = 'https://twitter.com/intent/tweet?text=' + encodeURIComponent(
      `My vote: ${w.name}. The internet's first dad-only Mobile Legends esports team is real. ggdad.gg`
    );
    window.open(tw, '_blank');
  });

  update();
}
